export function languageReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        
        case "UPDATE_LANG":
            return payload;
       
        default:
            return state;
    }
    
}
